import styled from '@emotion/styled';
import { media, Svg, SvgProps } from '@dizraptors/ui-kit';
import React from 'react';

export const Button = styled('div')`
  position: fixed;
  right: 1.6rem;
  bottom: 1.6rem;
  width: 6.4rem;
  height: 6.4rem;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  cursor: pointer;
  background-color: black;

  @media ${media.phonablet} {
    display: none;
  }
`;

export const Icon = (props: SvgProps) => (
  <Svg {...props}>
    <path
      d="m14 18 4 4v-4zm-7-12c-2.76142 0-5 2.23858-5 5 0 2.7614 2.23858 5 5 5h10c2.7614 0 5-2.2386 5-5 0-2.76142-2.2386-5-5-5z"
      fill="#fff"
    />{' '}
  </Svg>
);
